// What of Capability Setup is ready to show, by build.
//
// Run Assessment and Invite Team save to the backend and show everywhere. So
// does Publish Training, the one build flow for AI courses: the program holds
// what it is built from, and the generator builds from it (DA-5041). Still only
// for orgs with the Capability release. Turning it off hands Course > Build with
// Elliott back to the chat, and recommendations to Add New Program.

export const creationFlowsReady = (): boolean => true;
export const trainingFlowReady = (): boolean => true;

// A Role Excellence program is for roles, and the backend holds them as its
// audience: Invite & Finish enrols the people who hold them, and whoever takes
// one of those roles later joins on their own. The Members step says so.
export const roleAudienceReady = (): boolean => true;

// Shared capabilities (docs/PRD-capabilities-roundup.md): the org admin's
// Development and Standards capabilities, applied to the roles they choose, and
// the build flow's rules that come with them: every program is for roles, and
// any type can build capabilities (Role Excellence its roles' own, Development
// and Standards the shared ones). On everywhere: the backend keeps the sets,
// merges them into the roles they apply to, and takes roles and capabilities
// on every program type.
export const sharedCapabilitiesReady = (): boolean => true;
export const sharedCapabilitiesBackend = (): boolean => true;
